export default {
  zh: {
    noMessage: '还没有任何消息',
    dynamic: '动态'
  },
  en: {
    noMessage: 'No notifications yet',
    dynamic: 'Notifications'
  }
}



// WEBPACK FOOTER //
// ./src/views/notification/lang.js